(function() {
  "use strict";

    angular.module("eSign")
    .directive('numbersValidation', function(){
        return {
          require: 'ngModel',
          link: function(scope, element, attrs, modelCtrl) {

            // Ensures that the input only containts digits.
            modelCtrl.$parsers.push(function (inputValue) {
              var transformedInput = inputValue.replace(/\D/g, '');
              if (transformedInput!=inputValue) {
                modelCtrl.$setViewValue(transformedInput);
                modelCtrl.$render();
              }
              return transformedInput;
            });

          }
        };
    });
}());
